import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    productCategory: {},
    businessGroup: {},
    respondentSettingsStudyType: null,
    respondentSettingsStudyTypeMethod: null,
};

export const settingsStore = createSlice({
    name: "settingsStore",
    initialState,
    reducers: {
        loadProductCategoryState: (state, action) => {
            state.productCategory = action.payload;
        },
        loadBusinessGroupState: (state, action) => {
            state.businessGroup = action.payload;
        },
        loadRespondentSettingsStudyType: (state, action) => {
            state.respondentSettingsStudyType = action.payload;
        },
        loadRespondentSettingsStudyTypeMethod: (state, action) => {
            state.respondentSettingsStudyTypeMethod = action.payload;
        },
    },
});

export const { loadProductCategoryState, loadBusinessGroupState, loadRespondentSettingsStudyType, loadRespondentSettingsStudyTypeMethod } = settingsStore.actions;

export default settingsStore.reducer;
